export default __webpack_public_path__ + "8a9c9f5db43d3d0c4fffa06acf99dad2.svg";